import axios from 'axios'
export default {
	namespaced: true,
	state: {
		endpoint: '/document/object/member/type',
		name: 'DocumentObjectMemberType',
		title: {
			single: 'DocumentObjectMemberType',
			plural: 'DocumentObjectMemberTypes'
		},
		icon: 'mdi-format-list-bulleted-type',
		items: [],
	},
	actions: {
		load (context, data) {
			return axios.get(context.getters.endpoint).then(response => {
				context.commit('items', response.data)
			}, error => {
				console.log('error', error)
			})
		},
	},
}
